/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Ledger_Filter_FromInputs */



/**
* | output |
* | --- |
* | "From date" |
*
* @param {Promo_Ledger_Filter_FromInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_ledger_filter_from = /** @type {((inputs?: Promo_Ledger_Filter_FromInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Ledger_Filter_FromInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Date de début")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fecha desde")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Data inicial")
	if (locale === "it") return /** @type {LocalizedString} */ ("Data di inizio")
	return /** @type {LocalizedString} */ ("From date")
});